import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete, Chip } from 'material-ui';
import { getTranslationByLocale } from '../../utils/TranslationUtils';
import { regscape } from '../../utils/StringUtils';

export const VenueField = ({ choices = [], searchText, handleSearch, handleSelectVenue }) => (
  <div>
    <AutoComplete
      floatingLabelText="Venues"
      fullWidth
      dataSource={choices}
      dataSourceConfig={{ text: 'text', value: 'id' }}
      searchText={searchText}
      onUpdateInput={(searchText) => handleSearch(searchText)} // eslint-disable-line no-shadow
      onNewRequest={(req) => handleSelectVenue(req)}
      filter={(searchText, key) => ( // eslint-disable-line no-shadow
        new RegExp(
          regscape(searchText),
          'gi'
        ).test(key) // @returns bool
      )}
      openOnFocus
      listStyle={{ maxHeight: 600, overflow: 'auto' }}
    />
  </div>
);

VenueField.propTypes = {
  choices: PropTypes.array,
  searchText: PropTypes.string,
  handleSearch: PropTypes.func,
};

export const ProductsField = ({ choices = [], handleSearch, handleSelectProduct, searchText }) => (
  <div>
    <AutoComplete
      floatingLabelText="Products"
      fullWidth
      dataSource={choices}
      dataSourceConfig={{ text: 'text', value: 'code' }}
      searchText={searchText}
      onUpdateInput={(searchText) => handleSearch(searchText)} // eslint-disable-line no-shadow
      onNewRequest={(req) => handleSelectProduct(req)}
      filter={(searchText, key) => searchText.length > 2 && // eslint-disable-line no-shadow
        new RegExp(
          regscape(searchText),
          'gi'
        ).test(key) // @returns bool
      }
      listStyle={{ maxHeight: 600, overflow: 'auto' }}
    />
  </div>
);

ProductsField.propTypes = {
  choices: PropTypes.array,
  searchText: PropTypes.string,
  handleSearch: PropTypes.func,
  handleSelectProduct: PropTypes.func,
};

export const ChipRenderer = ({ values, handleRequestDelete, locale, source, translate }) => (
  <div className="chip-container">
    {
      values && values.length > 10 ?
        `${values.length} ${source} ${translate('statistics.selected')}.` :
        values && values.map((val) => <Chip className="chip" onRequestDelete={() => handleRequestDelete(val._id, source)} key={val._id}>{getTranslationByLocale(val.title, locale)}</Chip>)}
  </div>
);
